import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subject, takeUntil } from "rxjs";
import { Store } from "@ngxs/store";
import { BroadcastService, TelemetryEventService } from "@cv-invision/core";
// Models
import { QualityState } from "../../../state/quality.state";
import { OrderDetailModel } from "../../../state/model/order-detail.model";
// Service
import { QualityDocumentService } from "../../../service/document-quality.service";
import { DROPDOWN_BUTTON_ITEM_TYPE, DropdownButtonItem } from "@cv-invision/cv.component-library.ux";

@Component({
	selector: 'cv-overview-sub-header-available-pdf',
	templateUrl: './available-pdf.component.html',
	styleUrls: ['./available-pdf.component.scss'],
})
export class AvailablePdfComponent implements OnInit, OnDestroy {
	orderDetail$: Observable<OrderDetailModel> = this.store.select(QualityState.getOrderDetail);
	isLoading = false;
	order: OrderDetailModel;
	availablePdf: DropdownButtonItem[] = [];

	private atComponentDestroy = new Subject();

	constructor(
		private qualityDocumentService: QualityDocumentService,
		private broadcastService: BroadcastService,
		private store: Store,
		private telemetryEventService: TelemetryEventService
	){
		this.availablePdf = [];
	}

	ngOnInit(): void {
		this.orderDetail$.pipe(takeUntil(this.atComponentDestroy)).subscribe((order: any) => {
			this.order = order;
		});
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}

	/**
	 * Event that retrives all available PDF files and show the list
	 */
	loadOrderAvailablePdf(): void {
		this.availablePdf = [
			{
				type: DROPDOWN_BUTTON_ITEM_TYPE.OPTION,
				label: 'Loading...',
				icon: 'fa-spinner fa-spin'
			}
		];
		const orderId = this.order.id;
		this.qualityDocumentService.getOrderAvailablePdf(orderId).subscribe(data => {
			if (data && data.length) {
				this.availablePdf = [];
				data.forEach(element => {
					this.availablePdf.push(
						{
							type: DROPDOWN_BUTTON_ITEM_TYPE.OPTION,
							label: element.label,
							data: element
						}
					)
				});
			} else {
				this.availablePdf = [
					{
						type: DROPDOWN_BUTTON_ITEM_TYPE.LABEL,
						label: 'No Reports available'
					}
				];
			}
		});
	}

	/**
	 * Event that will trigger the download of the PDF file
	 * @param event
	 */
	downloadAvailablePdf(event: any): void {
		this.isLoading = true;
		this.qualityDocumentService.downloadNonChachedPDFFile(this.order.id, event.item.data.key).subscribe(data => {
			if ('blob' in data) {
				this.onDownloadPDF(data.blob, `${this.order.id}_${event.item.data.key}`);
				this.isLoading = false;
			}
		});

	}

	/**
	 * Download PDF file..
	 */
	onDownloadPDF(src: any = null, filename: string = null): void {
		const element = document.createElement('a');
		element.href = URL.createObjectURL(src);
		element.download = `${filename}.pdf`;
		document.body.appendChild(element);
		element.click();
	}
}
